import { createGetCurrentHistoryStackEntrySelector } from '../../history-stack';
import { getAdminPanelsHistory } from './get-admin-panels-history';

export const getCurrentAdminPanelsHistoryEntry = createGetCurrentHistoryStackEntrySelector(
  getAdminPanelsHistory,
);
